import { Link } from "react-router";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section className="py-10 relative xl:mr-0 lg:mr-5 mr-0">
      <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
        <div className="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-1 grid-cols-1">
          
          <motion.div
            className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <div className="w-full flex-col justify-center items-start gap-8 flex">
              <div className="flex-col justify-start lg:items-start items-center gap-4 flex">
                <h6 className="text-gray-400 text-base font-sans leading-relaxed">Evoteam haqida</h6>
                <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                  <h2 className="text-[#2766be] text-2xl font-bold font-manrope leading-normal lg:text-start text-center">
                  Evoteam – bu yosh va iqtidorli dasturchilar jamoasi bo‘lib, zamonaviy texnologiyalar asosida foydali va innovatsion loyihalarni yaratishga intiladi. Jamoa asosiy e’tiborni veb-dasturlash, dizayn va raqamli mahsulotlar ishlab chiqishga qaratgan. 
                  </h2>
                  <p className="text-gray-500 text-base font-normal leading-relaxed lg:text-start text-center">
                  Evoteamning asosiy maqsadi – bilim va tajriba almashish orqali birgalikda o‘sish va jamiyatga foyda keltiruvchi loyihalarni amalga oshirishdir.
                  </p>
                </div>
              </div>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              className="sm:w-fit w-full group px-3.5 py-2 bg-indigo-50 hover:bg-indigo-100 rounded-lg shadow transition-all duration-700 ease-in-out justify-center items-center flex"
            >
              <Link to={'/biz-haqimizda'} className="px-1.5 text-indigo-600 text-sm font-medium leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out font-sans">
              Batafsil
              </Link>
              <svg className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996" stroke="#4F46E5" strokeWidth="1.6"
                  strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </motion.button>
          </motion.div>

          <motion.div
            className="w-full lg:justify-start justify-center items-start flex"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <div className="sm:w-[964px] w-full sm:h-[646px] h-full rounded-3xl sm:border border-gray-200 relative mx-auto">
              <img className="sm:mt-5 sm:ml-5 w-full h-full object-cover"
                src="/img/our-team.jpg" alt="about Us imag" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;
